import angular from 'angular'
import Notificacoes from '../../service/Notificacoes'

import { Subject } from 'rx'

class EfNotificacoes {
    static get $inject() {
        return ['$scope', '$uibModal', 'pathService', 'Notificacoes', 'Alert']
    }

    /**
     * 
     * @param {angular.IScope} $scope
     * @param {Notificacoes} Notificacoes 
     */
    constructor($scope, modal, pathService, Notificacoes, Alert) {
        this.apply = fn => $scope.$apply(fn)
        this.notificacoes = []
        this.tarefas = []
        this.items = []
        this.subscriptions = []

        this.$pathService = pathService;
        this.$modal = modal
        this.$Notificacoes = Notificacoes;
	this.$Alert = Alert;

        this.$countNotifier = new Subject()
        this.$scrollNotifier = new Subject()
        this.$markTarefasAsReadNotifier = new Subject()
        this.$markNotificacoesAsReadNotifier = new Subject()
    }

    $onInit() {
        this.$countNotifier
            .debounce(1000)
            .subscribe(() => {
                this.$Notificacoes
                    .countNotificacoesAndTarefasNotRead()
                    .then(count => this.naoLidas = count)
                    .finally(() => this.apply())
            })

        this.$scrollNotifier
            .debounce(500)
            .subscribe(() => {
                this.fetchNotificacoesAndTarefas()
            })

        this.$markTarefasAsReadNotifier
            .bufferTime(3000)
            .subscribe(tarefasIds => {
                if (tarefasIds.length > 0) {
                    this.markTarefasAsRead(tarefasIds)
                }
            })

        this.$markNotificacoesAsReadNotifier
            .bufferTime(3000)
            .subscribe(notificacoesIds => {
                if (notificacoesIds.length > 0) {
                    this.markNotificacoesAsRead(notificacoesIds)
                }
            })

        this._subscribeToTarefaCreated()
        this._subscribeToTarefaDeleted()

        this._subscribeToNotificacaoCreated()
        this._subscribeToNotificacaoDeleted()

        this.$countNotifier.onNext()
    }

    $onDestroy() {
        this.subscriptions.forEach(unsub => unsub())
    }

    deleteAllNotificacoes() {
        this.loading = this.$Notificacoes
            .deleteAllNotificacoes()
            .then(() => {
		this.$Alert.success(
		    "Sua caixa de notificações agora está limpa!",
		    "Sucesso"
		);
		this.notificacoes = [];
	        this.tarefas = [];
                this._updateState()
            })
            .catch(console.error);
    }

    downloadAnexo(notificacao, anexo) {
        notificacao.loading = true

        this.$Notificacoes
            .downloadAnexo(notificacao, anexo)
            .finally(() => this.apply(() => notificacao.loading = false))
    }

    imprimirNotificacao(notificacao) {
        this.$Notificacoes.imprimirNotificacao(notificacao)
    }

    showModalNotificacao(notificacao) {
        this.$modal.open({
            size: 'md',
            backdrop: true,
            keyboard: true,
            templateUrl: this.$pathService.getViewUrl() + 'eficiencia-fiscal/view/notificacao-modal.html',
            controller: 'notificacaoModalController as ctrl',
            resolve: {
                notificacao: () => {
                    return {
                        id: notificacao.id,
                        titulo: notificacao.titulo,
                        conteudo: notificacao.conteudo
                    }
                }
            }
        })
    }

    inView(inView, notificacaoOrTarefa) {
        if (!inView || notificacaoOrTarefa.lida) return;

        if (notificacaoOrTarefa.type === 'tarefa') {
            this.$markTarefasAsReadNotifier.onNext(notificacaoOrTarefa.id)
        } else {
            this.$markNotificacoesAsReadNotifier.onNext(notificacaoOrTarefa.id)
        }
    }

    markTarefasAsRead(tarefasIds) {
        this.$Notificacoes
            .markTarefasAsRead(tarefasIds)
            .then((tarefas) => {
                this.tarefas = [...tarefas, ...this.tarefas].uniqBy(n => n.id).sort((a, b) => b.id - a.id)
                this._updateState()
            })
            .finally(() => this.apply())
    }

    markNotificacoesAsRead(notificacoesIds) {
        this.$Notificacoes
            .markNotificacoesAsRead(notificacoesIds)
            .then((notificacoes) => {
                this.notificacoes = [...notificacoes, ...this.notificacoes].uniqBy(n => n.id).sort((a, b) => b.id - a.id)
                this._updateState()
            })
            .finally(() => this.apply())
    }

    fetchNotificacoesAndTarefas() {
        const notificacaoParams = this.lastNotificacao ? { idLt: this.lastNotificacao.toString() } : {}
        const tarefaParams = this.lastTarefa ? { idLt: this.lastTarefa.toString() } : {}

        return this.loading = this.$Notificacoes
            .listNotificacoesAndTarefas(notificacaoParams, tarefaParams)
            .then(({ notificacoes, tarefas }) => {
                this.notificacoes = [...this.notificacoes, ...notificacoes].uniqBy(n => n.id)
                this.tarefas = [...this.tarefas, ...tarefas].uniqBy(n => n.id)

                this._updateState()
            })
            .catch(console.error)
            .finally(() => this.apply())
    }

    resetState() {
        this.notificacoes = []
        this.tarefas = []
        this.items = []
        this.lastNotificacao = null
        this.lastTarefa = null
    }

    _subscribeToTarefaCreated() {
        const subscription = this.$Notificacoes.onCreateTarefa(this.usuarioId.toString(), tarefa => {
            this.apply(() => {
                this.tarefas.unshift(tarefa)
                this._updateState()
            })
        })

        this.subscriptions.push(subscription)
    }

    _subscribeToTarefaDeleted() {
        const subscription = this.$Notificacoes.onDeleteTarefa(this.usuarioId.toString(), tarefa => {
            this.apply(() => {
                this.tarefas = this._removeFrom(this.tarefas, tarefa)
                this._updateState()
            })
        })

        this.subscriptions.push(subscription)
    }

    _subscribeToNotificacaoCreated() {
        const subscription = this.$Notificacoes.onCreateNotificacao(this.usuarioId.toString(), notificacao => {
            this.apply(() => {
                this.notificacoes.unshift(notificacao)
                this._updateState()
            })
        })

        this.subscriptions.push(subscription)
    }

    _subscribeToNotificacaoDeleted() {
        const subscription = this.$Notificacoes.onDeleteNotificacao(this.usuarioId.toString(), notificacao => {
            this.apply(() => {
                this.notificacoes = this._removeFrom(this.notificacoes, notificacao)
                this._updateState()
            })
        })

        this.subscriptions.push(subscription)
    }

    _updateState() {
        this.items = this._listItems()

        this.$countNotifier.onNext()

        this.lastNotificacao = this._minId(this.notificacoes)
        this.lastTarefa = this._minId(this.tarefas)

        this.lastUpdated = new Date()
    }

    _minId(tarefasOrNotificacoes) {
        if (tarefasOrNotificacoes.length)
            return Math.min(...tarefasOrNotificacoes.map(n => n.id))
        else
            return 0
    }

    _removeFrom(notificacoesOrTarefas, notificacaoOrTarefa) {
        return notificacoesOrTarefas.reject(n => n.id === notificacaoOrTarefa.id)
    }

    _listItems() {
        return this
            .tarefas
            .map(tarefa => ({
                ...tarefa,
                type: "tarefa",
                track: `tarefa:${tarefa.id}`
            }))
            .concat(
                this.notificacoes
                    .map(notificacao => ({
                        ...notificacao,
                        type: "notificacao",
                        track: `notificacao:${notificacao.id}`
                    }))
            )
            .sort((i1, i2) => i1.insertedAt > i2.insertedAt ? -1 : 1)
            .uniqBy(n => n.track)
    }
}

angular
    .module('eficienciaFiscalModule')
    .component('efNotificacoes', {
        controller: EfNotificacoes,
        bindings: {
            usuarioId: '<'
        },
        template: `
        <script type="text/ng-template" id="notificacoes">
            <div class="clearfix" style="cursor: default; font-size: 12px; font-weight: normal;">
                <!-- Botões -->
                <div class="btn-group padding-10 col-xs-12" style="max-width: inherit; border-bottom: solid 1px rgba(177, 177, 177, 0.5)">
                    <h3 style="margin: 10px 0">Caixa de notificações</h3>
                </div>
                <promise-tracker promise="$context.loading" active="isLoading">
                <!-- Notificações -->
                    <div class="col-xs-12 no-padding">
                        <div class="pane-notificacoes">
                            <ef-infinite-scroll
                                ng-show="$context.items.length"
                                list-id="notificacoes-list"
                                init-action="$context.fetchNotificacoesAndTarefas()"
                                trigger-action="$context.$scrollNotifier.onNext()"
                                destroy-action="$context.resetState()"
                                in-view-container>
                                <ef-infinite-scroll-list-item
                                    ng-repeat="notificacao in $context.items track by notificacao.track"
                                    ng-class="{'new': !notificacao.lida}"
                                    list-item-id="notificacoes-list-item-{{ $index + 1 }}"
                                    in-view="$context.inView($inview, notificacao)">
                                    <!-- Tarefa -->
                                    <div ng-if="notificacao.type === 'tarefa'">
                                        <div class="task-title">
                                            {{ notificacao.titulo }} - <small class="text-muted">
                                                <i>Iniciada em {{ notificacao.insertedAt | date:'medium' }}</i>
                                            </small>
                                        </div>
                                        <div 
                                            ng-if="notificacao.status !== 'nao_finalizada'"
                                            class="progress progress-xs no-margin"
                                            ng-class="{'progress-striped active': notificacao.progresso == null && notificacao.status !== 'finalizada'}">
                                            <div 
                                                class="progress-bar progress-bar-primary" 
                                                role="progressbar"
                                                style="width: {{ notificacao.progresso == null || notificacao.status == 'finalizada' ? 100 : notificacao.progresso }}%">
                                            </div>
                                        </div>

                                        <div class="task-info">
                                            <span ng-switch="notificacao.status">
                                                <span ng-switch-when="aguardando">Aguardando</span>
                                                <span ng-switch-when="finalizada">Concluída</span>
                                                <span ng-switch-when="processando">
                                                    Processando <span ng-if="notificacao.progresso !== null">({{ notificacao.progresso }}%)</span>
                                                </span>
                                                <span class="help-block txt-color-red font-xs no-margin" ng-switch-when="nao_finalizada">
                                                    Ocorreu um erro ao executar essa tarefa.
                                                </span>
                                            </span>
                                        </div>
                                    </div>

                                    <!-- Notificacao -->
                                    <div ng-if="notificacao.type === 'notificacao'">
                                        <div class="notification-title">
                                            {{ notificacao.titulo }}

                                            <span ng-show="notificacao.loading" class="pull-right">
                                                <i class="fa fa-spin fa-spinner"></i>
                                            </span>
                                        </div>
                                        <div class="notification-contents">
                                            <div ng-if="notificacao.resumo" ng-bind-html="notificacao.resumo"></div>
                                            <div ng-if="!notificacao.resumo" ng-bind-html="notificacao.conteudo"></div>

                                            <div style="margin: 5px 0 0 0">                                                
                                                <i
                                                    ng-if="notificacao.anexos.length"
                                                    ng-repeat="anexo in notificacao.anexos"
                                                    class="fa fa-paperclip cursor-pointer notification-icon"
                                                    tooltip="{{ anexo.nome }}"
                                                    ng-click="$context.downloadAnexo(notificacao, anexo)">
                                                </i>
                                                <i
                                                    ng-if="notificacao.temConteudoAdicional"
                                                    class="fa fa-print cursor-pointer notification-icon"
                                                    tooltip="Imprimir"
                                                    ng-click="$context.imprimirNotificacao(notificacao)">
                                                </i>
                                            </div>

                                            <p style="margin: 5px 0 0 0" class="text-muted">
                                                <small><i>{{ notificacao.insertedAt | date:'medium' }}</i></small>
                                                <a ng-if="notificacao.temConteudoAdicional"
                                                ng-click="$context.showModalNotificacao(notificacao)"
                                                class="pull-right" href="javascript:void(0)">Ver mais</a>
                                            </p>
                                        </div>
                                    </div>
                                </ef-infinite-scroll-list-item>
                            </ef-infinite-scroll>

                            <div class="empty" ng-show="!$context.items.length">
                                <h1 class="text-center">
                                    Nenhuma notificação disponível.
                                    <br/>
                                    <small>Novas notificações serão listadas aqui de acordo com o seu uso do Eficiência Fiscal.</small>
                                </h1>
                            </div>
                        </div>
                        <div style="border-top: solid 1px rgba(177, 177, 177, 0.5); display: flex; align-items: center; justify-content:space-between; padding: 10px">
                            <span>
                                Última atualização em <i>{{ $context.lastUpdated | date:'mediumDate' }}</i> às <i>{{ $context.lastUpdated | date:'shortTime' }}</i>
                            </span>
			    <span class="cursor-pointer" ng-show="!isLoading">
			      <i ng-click="$context.deleteAllNotificacoes()"
				class="fa fa-trash-o text-danger"
				tooltip="Limpar caixa de notificações">
		              </i>
			    </span>
                            <span ng-show="isLoading">
                                <i class="fa fa-lg fa-spin fa-circle-o-notch"></i>
                            </span>
                        </div>
                    </div>
                </promise-tracker>
            </div>
        </script>
        <span class="popover-md">
            <span id="activity" class="activity-dropdown active"
                popover-template="notificacoes" popover-trigger="click focus"
                popover-context="$ctrl" popover-placement="bottom">
                <i class="fa fa-bell" ng-class="$ctrl.naoLidas > 0 ? 'text-danger' : 'text-info'"></i>
                <span class="badge"
                    ng-show="$ctrl.naoLidas > 0"
                    ng-bind="$ctrl.naoLidas"></span>
            </span>
        </span>
        `
    })
